import debug from "debug";

const log = debug("app:mkpart");

/**
 * Class for handling geometry switching between 2D and 3D views.
 * @category Experience
 * @subcategory World
 */
export default class GeometrySwitcher {
  /**
   * Constructs the GeometrySwitcher instance.
   * @param {Object} experience - The main experience object containing scene, event hub, and other dependencies.
   */
  constructor(experience) {
    this.experience = experience;
    this.eventHub = this.experience.eventHub;
    this.viewMode = { "3d": false };

    this._toggleGeometryBound = this.toggleGeometry.bind(this);
    this.eventHub.on("3d-enabled", this._toggleGeometryBound);
  }

  cleanup() {
    // Remove event listeners (must use same reference as on())
    if (this.eventHub) {
      this.eventHub.off("3d-enabled", this._toggleGeometryBound);
    }

    // Clear references
    this.experience = null;
    this.eventHub = null;
    this.viewMode = null;
}


  /**
   * Toggles between 3D models and normal part representations based on the view mode.
   */
  async toggleGeometry() {
    log("Switching Geometry Mode", this.viewMode);

    if (!this.viewMode["3d"]) {
      // Traverse and remove all "Shape" children for objects with "XMO" and glb defined
      this.experience.scene.children.forEach((object) => {
        if (object.userData?.XMO && object.userData?.glb) {
          object.children = object.children.filter(
            (child) => child.name !== "Shape"
          );
          log(`Removed 'Shape' from object:`, object);
        }
      });
    }

    const currentXMD = this.experience.xmdVault;

    await new Promise((resolve) => {
      this.eventHub.emit("deleteScene", { reason: "mode-switch" });
      setTimeout(resolve, 500); // Minimal wait before reloading parts
    });

    this.eventHub.emit("MakePartsLoaderEvent", {
      eventType: "load",
      data: currentXMD,
      reason: "mode-switch",
    });
  }
}
